




















































import Vue from "vue";
import { Component, Prop, Watch } from "vue-property-decorator";
import ExternalReviewerList from "./ExternalReviewerList.vue";
import ExternalReviewerGrid from "./ExternalReviewerGrid.vue";
import DashboardFilterComponent from "./Filter/DashboardFilter.vue";
import { http } from "@/shared/https";
import AdvanceSearchComponent from "@/components/common/AdvanceFilter/AdvanceSearch.vue";
import { ReportFilter, ReportParameter } from "@/entities";

@Component({
  components: {
    ExternalReviewerList,
    ExternalReviewerGrid,
    DashboardFilterComponent,
    AdvanceSearchComponent
  },
})
export default class ExternalReviewerDashboardLayoutComponent extends Vue {
  @Prop() entity!: any;
  reviews: Array<any> = [];
  collapsed = false;
  isTabView: boolean = false;
  filters: Array<any> = [];
  filterItem: Array<any> = [];
  selectedParams: Array<ReportParameter> = [];
  tabs = [
    {
      component: "ExternalReviewerList",
      text: "Card View",
      icon: "mdi-view-grid",
    },
    {
      component: "ExternalReviewerGrid",
      text: "Grid View",
      icon: "mdi-format-list-bulleted-square",
    },
  ];
  currentTab = this.tabs[0];
  previousTab: any;

  mounted() {
    this.getFilters();
    this.getLeftPanelFilter();
  }

  getLeftPanelFilter(){
    var entitytype = this.entity;
    http.get(`api/ReviewExternal/GetFilter/${entitytype}`).then((resp: any) => {
      if (resp.status >= 200 && resp.status < 300) {
        this.filterItem = resp.data;
      }
    });    
  }

  switchLayout(isTabView) {
    this.isTabView = !isTabView;

    if (this.isTabView) {
      this.currentTab = this.tabs[1];
    } else {
      this.currentTab = this.tabs[0];
    }
  }
  listProposal() {
    return this.$services.review.listProposals(this.entity);
  }

  /*switchToConsolidated() {
    this.previousTab = this.currentTab
    this.currentTab = this.consolidatedTab[0];
    this.currentTab.text = this.previousTab.text;
    this.currentTab.icon = this.previousTab.icon;
  }*/
  listReviews(e) {
    let filteredData = '';
    var self = this;
    var entitytype = this.entity;
    http.get(`/api/ReviewExternal/${entitytype}?${e}`).then((resp: any) => {
      if (resp.data && resp.data.Items) {
        self.reviews = resp.data.Items;
      }
      if(resp.data.Filters != null){
        filteredData = JSON.stringify(resp.data.Filters);
      }
      
      let initialFilter = JSON.stringify(self.filterItem);
      if(filteredData && filteredData !== initialFilter){
        self.filterItem = resp.data.Filters;
      }
    });
  }
  getFilters() {
    http.get(`api/ReviewExternal/AdvanceFilter`).then((resp: any) => {
      if (resp.status >= 200 && resp.status < 300 && resp.data) {
        this.filters = resp.data;
      }
    });
  }

  onSearch() 
  {
     http.post(`api/ReviewExternal/${this.entity}/Filter`, this.selectedParams)
        .then((resp: any) => {
          console.log(resp)
          if (resp.status >= 200 && resp.status < 300) {
            this.reviews = resp.data.Items || [];
          }
        });
  }
  collapseFilter() {
    this.collapsed = !this.collapsed;
  }
  @Watch("$route", { immediate: true, deep: true })
  onUrlChange(changedRoute: any) {
    if (changedRoute && changedRoute.name === "dashboard") {
      this.listProposal().then((data: any) => {
        this.reviews = data;
      });
    }
  }
  get currentTabComponent() {
    return this.currentTab.component;
  }
}
